/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/delivery/service.proto" (package "rd.api.delivery", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { Delivery } from "../../txn/models_pb";
import { DeliveryStop_DeliveryAttempt } from "../../txn/models_pb";
import { DeliveryStop_Status } from "../../txn/models_pb";
import { DeliveryDetails } from "../../txn/models_pb";
import { SaleKit } from "../../txn/models_pb";
import { GiftCard } from "../../giftcard/models_pb";
import { TintColor } from "../../tintcolor/models_pb";
import { Product } from "../../product/models_pb";
import { SaleProduct } from "../../txn/models_pb";
import { Customer } from "../../customer/models_pb";
import { Sale } from "../../txn/models_pb";
import { DeliveryStop } from "../../txn/models_pb";
import { Location } from "../../company/models_pb";
import { Staff } from "../../company/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Delivery_Status } from "../../txn/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryReq
 */
export interface GetDeliveryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryRes
 */
export interface GetDeliveryRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Delivery.Status status = 3
     */
    status: Delivery_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp departure_time = 4
     */
    departureTime?: Timestamp;
    /**
     * @generated from protobuf field: string carrier = 5
     */
    carrier: string;
    /**
     * @generated from protobuf field: rd.company.Staff assigned_to = 6
     */
    assignedTo?: Staff;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * @generated from protobuf field: string internal_notes = 8
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: repeated rd.api.delivery.GetDeliveryRes.StopLineItem stop_line_items = 9
     */
    stopLineItems: GetDeliveryRes_StopLineItem[];
    /**
     * @generated from protobuf field: bool is_departure_time_entered = 10
     */
    isDepartureTimeEntered: boolean;
    /**
     * @generated from protobuf field: rd.company.Location location = 11
     */
    location?: Location; // dispatched from
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem
 */
export interface GetDeliveryRes_StopLineItem {
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop stop = 1
     */
    stop?: DeliveryStop;
    /**
     * @generated from protobuf field: repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData attached_transaction_data = 2
     */
    attachedTransactionData: GetDeliveryRes_StopLineItem_AttachedTransactionData[];
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData
 */
export interface GetDeliveryRes_StopLineItem_AttachedTransactionData {
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 1
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 3
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData sale_product_data = 4
     */
    saleProductData: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData[];
    /**
     * @generated from protobuf field: repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData sale_kit_data = 5
     */
    saleKitData: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData[];
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData
 */
export interface GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData {
    /**
     * @generated from protobuf field: rd.txn.SaleProduct sale_product = 1
     */
    saleProduct?: SaleProduct;
    /**
     * @generated from protobuf field: rd.product.Product product = 2
     */
    product?: Product;
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 3
     */
    tintColor?: TintColor;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard gift_card = 4
     */
    giftCard?: GiftCard;
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData
 */
export interface GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData {
    /**
     * @generated from protobuf field: rd.txn.SaleKit sale_kit = 1
     */
    saleKit?: SaleKit;
    /**
     * @generated from protobuf field: rd.product.Product product = 2
     */
    product?: Product; // the kit product
}
/**
 * DeliveryStopInput is a shared abstraction to take in data from the client for a stop.
 * An input with an id uses that stop on the delivery. Without one, it makes a new stop.
 *
 * @generated from protobuf message rd.api.delivery.DeliveryStopInput
 */
export interface DeliveryStopInput {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails details = 2
     */
    details?: DeliveryDetails;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 3
     */
    saleIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 4
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: string internal_notes = 5
     */
    internalNotes: string;
}
/**
 * @generated from protobuf message rd.api.delivery.CreateDeliveryReq
 */
export interface CreateDeliveryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp departure_time = 2
     */
    departureTime?: Timestamp;
    /**
     * @generated from protobuf field: string carrier = 3
     */
    carrier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID assigned_to_staff_id = 4
     */
    assignedToStaffId?: UUID;
    /**
     * @generated from protobuf field: string notes = 5
     */
    notes: string;
    /**
     * @generated from protobuf field: string internal_notes = 6
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: repeated rd.api.delivery.DeliveryStopInput stops = 7
     */
    stops: DeliveryStopInput[];
    /**
     * @generated from protobuf field: bool is_departure_time_entered = 8
     */
    isDepartureTimeEntered: boolean;
}
/**
 * @generated from protobuf message rd.api.delivery.CreateDeliveryRes
 */
export interface CreateDeliveryRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.UpdateDeliveryReq
 */
export interface UpdateDeliveryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.txn.Delivery.Status next_status = 2
     */
    nextStatus: Delivery_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp departure_time = 3
     */
    departureTime?: Timestamp;
    /**
     * @generated from protobuf field: string carrier = 4
     */
    carrier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID assigned_to_staff_id = 5
     */
    assignedToStaffId?: UUID;
    /**
     * @generated from protobuf field: string notes = 6
     */
    notes: string;
    /**
     * @generated from protobuf field: string internal_notes = 7
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: repeated rd.api.delivery.DeliveryStopInput stops = 8
     */
    stops: DeliveryStopInput[]; // Replaces all delivery stops. Removed stops are staged if
    /**
     * they have sales or deleted otherwise.
     *
     * @generated from protobuf field: bool skip_stops = 9
     */
    skipStops: boolean; // When true, stops are left unchanged and the stops field is ignored.
    /**
     * @generated from protobuf field: optional bool is_departure_time_entered = 10
     */
    isDepartureTimeEntered?: boolean; // Left unchanged when unset.
}
/**
 * @generated from protobuf message rd.api.delivery.UpdateDeliveryRes
 */
export interface UpdateDeliveryRes {
}
/**
 * @generated from protobuf message rd.api.delivery.UpdateDeliveryStopReq
 */
export interface UpdateDeliveryStopReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID dispatch_location_id = 2
     */
    dispatchLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails details = 3
     */
    details?: DeliveryDetails;
    /**
     * @generated from protobuf field: optional string internal_notes = 4
     */
    internalNotes?: string;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 5
     */
    saleIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 6
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop.Status status = 7
     */
    status: DeliveryStop_Status;
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop.DeliveryAttempt delivery_attempt = 8
     */
    deliveryAttempt?: DeliveryStop_DeliveryAttempt;
}
/**
 * @generated from protobuf message rd.api.delivery.UpdateDeliveryStopRes
 */
export interface UpdateDeliveryStopRes {
}
/**
 * @generated from protobuf message rd.api.delivery.StageSaleReq
 */
export interface StageSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails details = 2
     */
    details?: DeliveryDetails;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID staged_stop_id = 3
     */
    stagedStopId?: UUID; // If nil, creates a new stop for the sale. If not nil, edits the staged stop.
}
/**
 * @generated from protobuf message rd.api.delivery.StageSaleRes
 */
export interface StageSaleRes {
}
/**
 * @generated from protobuf message rd.api.delivery.UnstageSaleReq
 */
export interface UnstageSaleReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 2
     */
    stopId?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.UnstageSaleRes
 */
export interface UnstageSaleRes {
}
/**
 * @generated from protobuf message rd.api.delivery.AttachSaleToDeliveryReq
 */
export interface AttachSaleToDeliveryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 1
     */
    deliveryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails details = 3
     */
    details?: DeliveryDetails;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 4
     */
    stopId?: UUID; // If nil, creates a new stop for the sale. If not nil, attaches to the stop.
}
/**
 * @generated from protobuf message rd.api.delivery.AttachSaleToDeliveryRes
 */
export interface AttachSaleToDeliveryRes {
}
/**
 * @generated from protobuf message rd.api.delivery.MoveStagedSaleToStopReq
 */
export interface MoveStagedSaleToStopReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 1
     */
    deliveryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 3
     */
    stopId?: UUID; // If nil, creates a new stop for the sale. If not nil, attaches to the stop.
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID staged_stop_id = 4
     */
    stagedStopId?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.MoveStagedSaleToStopRes
 */
export interface MoveStagedSaleToStopRes {
}
/**
 * @generated from protobuf message rd.api.delivery.RemoveSaleFromStopReq
 */
export interface RemoveSaleFromStopReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 1
     */
    deliveryId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 2
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 3
     */
    stopId?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.RemoveSaleFromStopRes
 */
export interface RemoveSaleFromStopRes {
}
/**
 * RemoveSaleFromDelivery removes the sale outright instead of restaging it.
 *
 * @generated from protobuf message rd.api.delivery.RemoveSaleFromDeliveryReq
 */
export interface RemoveSaleFromDeliveryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 1
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 2
     */
    stopId?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.RemoveSaleFromDeliveryRes
 */
export interface RemoveSaleFromDeliveryRes {
}
/**
 * GetDeliveryPDF returns a single pdf covering every stop on the delivery.
 *
 * @generated from protobuf message rd.api.delivery.GetDeliveryPDFReq
 */
export interface GetDeliveryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryPDFRes
 */
export interface GetDeliveryPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
    /**
     * @generated from protobuf field: string file_name = 2
     */
    fileName: string;
}
/**
 * @generated from protobuf message rd.api.delivery.EmailDeliveryPDFReq
 */
export interface EmailDeliveryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
}
/**
 * @generated from protobuf message rd.api.delivery.EmailDeliveryPDFRes
 */
export interface EmailDeliveryPDFRes {
}
/**
 * GetDeliveryStopPDF returns a pdf for a single stop on the delivery.
 *
 * @generated from protobuf message rd.api.delivery.GetDeliveryStopPDFReq
 */
export interface GetDeliveryStopPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 1
     */
    stopId?: UUID;
}
/**
 * @generated from protobuf message rd.api.delivery.GetDeliveryStopPDFRes
 */
export interface GetDeliveryStopPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * GetScannedDelivery looks up a delivery by the identifier encoded in its PDF barcode.
 *
 * @generated from protobuf message rd.api.delivery.GetScannedDeliveryReq
 */
export interface GetScannedDeliveryReq {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.api.delivery.GetScannedDeliveryRes
 */
export interface GetScannedDeliveryRes {
    /**
     * @generated from protobuf field: rd.txn.Delivery delivery = 1
     */
    delivery?: Delivery;
}
/**
 * @generated from protobuf message rd.api.delivery.LatLng
 */
export interface LatLng {
    /**
     * @generated from protobuf field: double lat = 1
     */
    lat: number;
    /**
     * @generated from protobuf field: double lng = 2
     */
    lng: number;
}
/**
 * OptimizeDeliveryStops proposes a stop order; the client geocodes, nothing is saved.
 *
 * @generated from protobuf message rd.api.delivery.OptimizeDeliveryStopsReq
 */
export interface OptimizeDeliveryStopsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp depart_at = 2
     */
    departAt?: Timestamp; // defaults to the delivery's
    /**
     * @generated from protobuf field: rd.api.delivery.LatLng origin = 3
     */
    origin?: LatLng; // dispatch location
    /**
     * @generated from protobuf field: repeated rd.api.delivery.OptimizeDeliveryStopsReq.Stop stops = 4
     */
    stops: OptimizeDeliveryStopsReq_Stop[]; // the stops in the cart, saved or not
}
/**
 * @generated from protobuf message rd.api.delivery.OptimizeDeliveryStopsReq.Stop
 */
export interface OptimizeDeliveryStopsReq_Stop {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // echoed back as is, so an unsaved stop can send its draft key
    /**
     * @generated from protobuf field: rd.api.delivery.LatLng location = 2
     */
    location?: LatLng;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange window = 3
     */
    window?: TimestampRange; // requested, absolute; breaks ties between routes
    /**
     * @generated from protobuf field: string label = 4
     */
    label: string; // names the stop in errors, e.g. its address
}
/**
 * @generated from protobuf message rd.api.delivery.OptimizeDeliveryStopsRes
 */
export interface OptimizeDeliveryStopsRes {
    /**
     * @generated from protobuf field: repeated rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop routed_stops = 1
     */
    routedStops: OptimizeDeliveryStopsRes_RoutedStop[]; // in route order
    /**
     * @generated from protobuf field: google.protobuf.Timestamp return_at = 2
     */
    returnAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop
 */
export interface OptimizeDeliveryStopsRes_RoutedStop {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID stop_id = 1
     */
    stopId?: UUID;
    /**
     * @generated from protobuf field: int32 position = 2
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: google.protobuf.Timestamp arrive_at = 3
     */
    arriveAt?: Timestamp;
    /**
     * @generated from protobuf field: bool misses_window = 4
     */
    missesWindow: boolean; // arrives outside the requested window; never without one
}
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryReq$Type extends MessageType<GetDeliveryReq> {
    constructor() {
        super("rd.api.delivery.GetDeliveryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryReq>): GetDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryReq): GetDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryReq
 */
export const GetDeliveryReq = new GetDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryRes$Type extends MessageType<GetDeliveryRes> {
    constructor() {
        super("rd.api.delivery.GetDeliveryRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "enum", T: () => ["rd.txn.Delivery.Status", Delivery_Status, "STATUS_"] },
            { no: 4, name: "departure_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "carrier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "assigned_to", kind: "message", T: () => Staff },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "stop_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetDeliveryRes_StopLineItem },
            { no: 10, name: "is_departure_time_entered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "location", kind: "message", T: () => Location }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryRes>): GetDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.status = 0;
        message.carrier = "";
        message.notes = "";
        message.internalNotes = "";
        message.stopLineItems = [];
        message.isDepartureTimeEntered = false;
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryRes): GetDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Delivery.Status status */ 3:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp departure_time */ 4:
                    message.departureTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.departureTime);
                    break;
                case /* string carrier */ 5:
                    message.carrier = reader.string();
                    break;
                case /* rd.company.Staff assigned_to */ 6:
                    message.assignedTo = Staff.internalBinaryRead(reader, reader.uint32(), options, message.assignedTo);
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* string internal_notes */ 8:
                    message.internalNotes = reader.string();
                    break;
                case /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem stop_line_items */ 9:
                    message.stopLineItems.push(GetDeliveryRes_StopLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_departure_time_entered */ 10:
                    message.isDepartureTimeEntered = reader.bool();
                    break;
                case /* rd.company.Location location */ 11:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Delivery.Status status = 3; */
        if (message.status !== 0)
            writer.tag(3, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp departure_time = 4; */
        if (message.departureTime)
            Timestamp.internalBinaryWrite(message.departureTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string carrier = 5; */
        if (message.carrier !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.carrier);
        /* rd.company.Staff assigned_to = 6; */
        if (message.assignedTo)
            Staff.internalBinaryWrite(message.assignedTo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* string internal_notes = 8; */
        if (message.internalNotes !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.internalNotes);
        /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem stop_line_items = 9; */
        for (let i = 0; i < message.stopLineItems.length; i++)
            GetDeliveryRes_StopLineItem.internalBinaryWrite(message.stopLineItems[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool is_departure_time_entered = 10; */
        if (message.isDepartureTimeEntered !== false)
            writer.tag(10, WireType.Varint).bool(message.isDepartureTimeEntered);
        /* rd.company.Location location = 11; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryRes
 */
export const GetDeliveryRes = new GetDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryRes_StopLineItem$Type extends MessageType<GetDeliveryRes_StopLineItem> {
    constructor() {
        super("rd.api.delivery.GetDeliveryRes.StopLineItem", [
            { no: 1, name: "stop", kind: "message", T: () => DeliveryStop },
            { no: 2, name: "attached_transaction_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetDeliveryRes_StopLineItem_AttachedTransactionData }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryRes_StopLineItem>): GetDeliveryRes_StopLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attachedTransactionData = [];
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryRes_StopLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryRes_StopLineItem): GetDeliveryRes_StopLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.DeliveryStop stop */ 1:
                    message.stop = DeliveryStop.internalBinaryRead(reader, reader.uint32(), options, message.stop);
                    break;
                case /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData attached_transaction_data */ 2:
                    message.attachedTransactionData.push(GetDeliveryRes_StopLineItem_AttachedTransactionData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryRes_StopLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.DeliveryStop stop = 1; */
        if (message.stop)
            DeliveryStop.internalBinaryWrite(message.stop, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData attached_transaction_data = 2; */
        for (let i = 0; i < message.attachedTransactionData.length; i++)
            GetDeliveryRes_StopLineItem_AttachedTransactionData.internalBinaryWrite(message.attachedTransactionData[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem
 */
export const GetDeliveryRes_StopLineItem = new GetDeliveryRes_StopLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryRes_StopLineItem_AttachedTransactionData$Type extends MessageType<GetDeliveryRes_StopLineItem_AttachedTransactionData> {
    constructor() {
        super("rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData", [
            { no: 1, name: "sale", kind: "message", T: () => Sale },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "customer", kind: "message", T: () => Customer },
            { no: 4, name: "sale_product_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData },
            { no: 5, name: "sale_kit_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryRes_StopLineItem_AttachedTransactionData>): GetDeliveryRes_StopLineItem_AttachedTransactionData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleProductData = [];
        message.saleKitData = [];
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryRes_StopLineItem_AttachedTransactionData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryRes_StopLineItem_AttachedTransactionData): GetDeliveryRes_StopLineItem_AttachedTransactionData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Sale sale */ 1:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 3:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData sale_product_data */ 4:
                    message.saleProductData.push(GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData sale_kit_data */ 5:
                    message.saleKitData.push(GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryRes_StopLineItem_AttachedTransactionData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Sale sale = 1; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 3; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData sale_product_data = 4; */
        for (let i = 0; i < message.saleProductData.length; i++)
            GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData.internalBinaryWrite(message.saleProductData[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData sale_kit_data = 5; */
        for (let i = 0; i < message.saleKitData.length; i++)
            GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData.internalBinaryWrite(message.saleKitData[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData
 */
export const GetDeliveryRes_StopLineItem_AttachedTransactionData = new GetDeliveryRes_StopLineItem_AttachedTransactionData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData$Type extends MessageType<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData> {
    constructor() {
        super("rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData", [
            { no: 1, name: "sale_product", kind: "message", T: () => SaleProduct },
            { no: 2, name: "product", kind: "message", T: () => Product },
            { no: 3, name: "tint_color", kind: "message", T: () => TintColor },
            { no: 4, name: "gift_card", kind: "message", T: () => GiftCard }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData>): GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData): GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.SaleProduct sale_product */ 1:
                    message.saleProduct = SaleProduct.internalBinaryRead(reader, reader.uint32(), options, message.saleProduct);
                    break;
                case /* rd.product.Product product */ 2:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                case /* rd.tintcolor.TintColor tint_color */ 3:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                case /* rd.giftcard.GiftCard gift_card */ 4:
                    message.giftCard = GiftCard.internalBinaryRead(reader, reader.uint32(), options, message.giftCard);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.SaleProduct sale_product = 1; */
        if (message.saleProduct)
            SaleProduct.internalBinaryWrite(message.saleProduct, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 2; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.tintcolor.TintColor tint_color = 3; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCard gift_card = 4; */
        if (message.giftCard)
            GiftCard.internalBinaryWrite(message.giftCard, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleProductData
 */
export const GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData = new GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleProductData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData$Type extends MessageType<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData> {
    constructor() {
        super("rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData", [
            { no: 1, name: "sale_kit", kind: "message", T: () => SaleKit },
            { no: 2, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData>): GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData): GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.SaleKit sale_kit */ 1:
                    message.saleKit = SaleKit.internalBinaryRead(reader, reader.uint32(), options, message.saleKit);
                    break;
                case /* rd.product.Product product */ 2:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.SaleKit sale_kit = 1; */
        if (message.saleKit)
            SaleKit.internalBinaryWrite(message.saleKit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 2; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryRes.StopLineItem.AttachedTransactionData.SaleKitData
 */
export const GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData = new GetDeliveryRes_StopLineItem_AttachedTransactionData_SaleKitData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryStopInput$Type extends MessageType<DeliveryStopInput> {
    constructor() {
        super("rd.api.delivery.DeliveryStopInput", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "details", kind: "message", T: () => DeliveryDetails, options: { "rd.validator.require": true } },
            { no: 3, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeliveryStopInput>): DeliveryStopInput {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleIds = [];
        message.customerIds = [];
        message.internalNotes = "";
        if (value !== undefined)
            reflectionMergePartial<DeliveryStopInput>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeliveryStopInput): DeliveryStopInput {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.txn.DeliveryDetails details */ 2:
                    message.details = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 3:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 4:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string internal_notes */ 5:
                    message.internalNotes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeliveryStopInput, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails details = 2; */
        if (message.details)
            DeliveryDetails.internalBinaryWrite(message.details, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_ids = 3; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 4; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 5; */
        if (message.internalNotes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.internalNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.DeliveryStopInput
 */
export const DeliveryStopInput = new DeliveryStopInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeliveryReq$Type extends MessageType<CreateDeliveryReq> {
    constructor() {
        super("rd.api.delivery.CreateDeliveryReq", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "departure_time", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 3, name: "carrier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "assigned_to_staff_id", kind: "message", T: () => UUID },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryStopInput },
            { no: 8, name: "is_departure_time_entered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateDeliveryReq>): CreateDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.carrier = "";
        message.notes = "";
        message.internalNotes = "";
        message.stops = [];
        message.isDepartureTimeEntered = false;
        if (value !== undefined)
            reflectionMergePartial<CreateDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDeliveryReq): CreateDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp departure_time */ 2:
                    message.departureTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.departureTime);
                    break;
                case /* string carrier */ 3:
                    message.carrier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID assigned_to_staff_id */ 4:
                    message.assignedToStaffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.assignedToStaffId);
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                case /* string internal_notes */ 6:
                    message.internalNotes = reader.string();
                    break;
                case /* repeated rd.api.delivery.DeliveryStopInput stops */ 7:
                    message.stops.push(DeliveryStopInput.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_departure_time_entered */ 8:
                    message.isDepartureTimeEntered = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp departure_time = 2; */
        if (message.departureTime)
            Timestamp.internalBinaryWrite(message.departureTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string carrier = 3; */
        if (message.carrier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.carrier);
        /* rd.proto.uuid.UUID assigned_to_staff_id = 4; */
        if (message.assignedToStaffId)
            UUID.internalBinaryWrite(message.assignedToStaffId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        /* string internal_notes = 6; */
        if (message.internalNotes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.internalNotes);
        /* repeated rd.api.delivery.DeliveryStopInput stops = 7; */
        for (let i = 0; i < message.stops.length; i++)
            DeliveryStopInput.internalBinaryWrite(message.stops[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_departure_time_entered = 8; */
        if (message.isDepartureTimeEntered !== false)
            writer.tag(8, WireType.Varint).bool(message.isDepartureTimeEntered);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.CreateDeliveryReq
 */
export const CreateDeliveryReq = new CreateDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeliveryRes$Type extends MessageType<CreateDeliveryRes> {
    constructor() {
        super("rd.api.delivery.CreateDeliveryRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateDeliveryRes>): CreateDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDeliveryRes): CreateDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.CreateDeliveryRes
 */
export const CreateDeliveryRes = new CreateDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryReq$Type extends MessageType<UpdateDeliveryReq> {
    constructor() {
        super("rd.api.delivery.UpdateDeliveryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "next_status", kind: "enum", T: () => ["rd.txn.Delivery.Status", Delivery_Status, "STATUS_"], options: { "rd.validator.require": true } },
            { no: 3, name: "departure_time", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 4, name: "carrier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "assigned_to_staff_id", kind: "message", T: () => UUID },
            { no: 6, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeliveryStopInput },
            { no: 9, name: "skip_stops", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "is_departure_time_entered", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateDeliveryReq>): UpdateDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextStatus = 0;
        message.carrier = "";
        message.notes = "";
        message.internalNotes = "";
        message.stops = [];
        message.skipStops = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDeliveryReq): UpdateDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.txn.Delivery.Status next_status */ 2:
                    message.nextStatus = reader.int32();
                    break;
                case /* google.protobuf.Timestamp departure_time */ 3:
                    message.departureTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.departureTime);
                    break;
                case /* string carrier */ 4:
                    message.carrier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID assigned_to_staff_id */ 5:
                    message.assignedToStaffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.assignedToStaffId);
                    break;
                case /* string notes */ 6:
                    message.notes = reader.string();
                    break;
                case /* string internal_notes */ 7:
                    message.internalNotes = reader.string();
                    break;
                case /* repeated rd.api.delivery.DeliveryStopInput stops */ 8:
                    message.stops.push(DeliveryStopInput.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool skip_stops */ 9:
                    message.skipStops = reader.bool();
                    break;
                case /* optional bool is_departure_time_entered */ 10:
                    message.isDepartureTimeEntered = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Delivery.Status next_status = 2; */
        if (message.nextStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.nextStatus);
        /* google.protobuf.Timestamp departure_time = 3; */
        if (message.departureTime)
            Timestamp.internalBinaryWrite(message.departureTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string carrier = 4; */
        if (message.carrier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.carrier);
        /* rd.proto.uuid.UUID assigned_to_staff_id = 5; */
        if (message.assignedToStaffId)
            UUID.internalBinaryWrite(message.assignedToStaffId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 6; */
        if (message.notes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.notes);
        /* string internal_notes = 7; */
        if (message.internalNotes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.internalNotes);
        /* repeated rd.api.delivery.DeliveryStopInput stops = 8; */
        for (let i = 0; i < message.stops.length; i++)
            DeliveryStopInput.internalBinaryWrite(message.stops[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool skip_stops = 9; */
        if (message.skipStops !== false)
            writer.tag(9, WireType.Varint).bool(message.skipStops);
        /* optional bool is_departure_time_entered = 10; */
        if (message.isDepartureTimeEntered !== undefined)
            writer.tag(10, WireType.Varint).bool(message.isDepartureTimeEntered);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UpdateDeliveryReq
 */
export const UpdateDeliveryReq = new UpdateDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryRes$Type extends MessageType<UpdateDeliveryRes> {
    constructor() {
        super("rd.api.delivery.UpdateDeliveryRes", []);
    }
    create(value?: PartialMessage<UpdateDeliveryRes>): UpdateDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDeliveryRes): UpdateDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UpdateDeliveryRes
 */
export const UpdateDeliveryRes = new UpdateDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryStopReq$Type extends MessageType<UpdateDeliveryStopReq> {
    constructor() {
        super("rd.api.delivery.UpdateDeliveryStopReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "dispatch_location_id", kind: "message", T: () => UUID },
            { no: 3, name: "details", kind: "message", T: () => DeliveryDetails },
            { no: 4, name: "internal_notes", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 6, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "status", kind: "enum", T: () => ["rd.txn.DeliveryStop.Status", DeliveryStop_Status, "STATUS_"] },
            { no: 8, name: "delivery_attempt", kind: "message", T: () => DeliveryStop_DeliveryAttempt }
        ]);
    }
    create(value?: PartialMessage<UpdateDeliveryStopReq>): UpdateDeliveryStopReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleIds = [];
        message.customerIds = [];
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateDeliveryStopReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDeliveryStopReq): UpdateDeliveryStopReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID dispatch_location_id */ 2:
                    message.dispatchLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.dispatchLocationId);
                    break;
                case /* rd.txn.DeliveryDetails details */ 3:
                    message.details = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* optional string internal_notes */ 4:
                    message.internalNotes = reader.string();
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 5:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 6:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.DeliveryStop.Status status */ 7:
                    message.status = reader.int32();
                    break;
                case /* rd.txn.DeliveryStop.DeliveryAttempt delivery_attempt */ 8:
                    message.deliveryAttempt = DeliveryStop_DeliveryAttempt.internalBinaryRead(reader, reader.uint32(), options, message.deliveryAttempt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDeliveryStopReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID dispatch_location_id = 2; */
        if (message.dispatchLocationId)
            UUID.internalBinaryWrite(message.dispatchLocationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails details = 3; */
        if (message.details)
            DeliveryDetails.internalBinaryWrite(message.details, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional string internal_notes = 4; */
        if (message.internalNotes !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.internalNotes);
        /* repeated rd.proto.uuid.UUID sale_ids = 5; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 6; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryStop.Status status = 7; */
        if (message.status !== 0)
            writer.tag(7, WireType.Varint).int32(message.status);
        /* rd.txn.DeliveryStop.DeliveryAttempt delivery_attempt = 8; */
        if (message.deliveryAttempt)
            DeliveryStop_DeliveryAttempt.internalBinaryWrite(message.deliveryAttempt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UpdateDeliveryStopReq
 */
export const UpdateDeliveryStopReq = new UpdateDeliveryStopReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeliveryStopRes$Type extends MessageType<UpdateDeliveryStopRes> {
    constructor() {
        super("rd.api.delivery.UpdateDeliveryStopRes", []);
    }
    create(value?: PartialMessage<UpdateDeliveryStopRes>): UpdateDeliveryStopRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateDeliveryStopRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDeliveryStopRes): UpdateDeliveryStopRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDeliveryStopRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UpdateDeliveryStopRes
 */
export const UpdateDeliveryStopRes = new UpdateDeliveryStopRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StageSaleReq$Type extends MessageType<StageSaleReq> {
    constructor() {
        super("rd.api.delivery.StageSaleReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "details", kind: "message", T: () => DeliveryDetails, options: { "rd.validator.require": true } },
            { no: 3, name: "staged_stop_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<StageSaleReq>): StageSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<StageSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StageSaleReq): StageSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.txn.DeliveryDetails details */ 2:
                    message.details = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* rd.proto.uuid.UUID staged_stop_id */ 3:
                    message.stagedStopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stagedStopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StageSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails details = 2; */
        if (message.details)
            DeliveryDetails.internalBinaryWrite(message.details, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID staged_stop_id = 3; */
        if (message.stagedStopId)
            UUID.internalBinaryWrite(message.stagedStopId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.StageSaleReq
 */
export const StageSaleReq = new StageSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StageSaleRes$Type extends MessageType<StageSaleRes> {
    constructor() {
        super("rd.api.delivery.StageSaleRes", []);
    }
    create(value?: PartialMessage<StageSaleRes>): StageSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<StageSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StageSaleRes): StageSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StageSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.StageSaleRes
 */
export const StageSaleRes = new StageSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnstageSaleReq$Type extends MessageType<UnstageSaleReq> {
    constructor() {
        super("rd.api.delivery.UnstageSaleReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stop_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UnstageSaleReq>): UnstageSaleReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UnstageSaleReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnstageSaleReq): UnstageSaleReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID stop_id */ 2:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnstageSaleReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID stop_id = 2; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UnstageSaleReq
 */
export const UnstageSaleReq = new UnstageSaleReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnstageSaleRes$Type extends MessageType<UnstageSaleRes> {
    constructor() {
        super("rd.api.delivery.UnstageSaleRes", []);
    }
    create(value?: PartialMessage<UnstageSaleRes>): UnstageSaleRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UnstageSaleRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnstageSaleRes): UnstageSaleRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnstageSaleRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.UnstageSaleRes
 */
export const UnstageSaleRes = new UnstageSaleRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachSaleToDeliveryReq$Type extends MessageType<AttachSaleToDeliveryReq> {
    constructor() {
        super("rd.api.delivery.AttachSaleToDeliveryReq", [
            { no: 1, name: "delivery_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "details", kind: "message", T: () => DeliveryDetails, options: { "rd.validator.require": true } },
            { no: 4, name: "stop_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<AttachSaleToDeliveryReq>): AttachSaleToDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AttachSaleToDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachSaleToDeliveryReq): AttachSaleToDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID delivery_id */ 1:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.txn.DeliveryDetails details */ 3:
                    message.details = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* rd.proto.uuid.UUID stop_id */ 4:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachSaleToDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID delivery_id = 1; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails details = 3; */
        if (message.details)
            DeliveryDetails.internalBinaryWrite(message.details, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID stop_id = 4; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.AttachSaleToDeliveryReq
 */
export const AttachSaleToDeliveryReq = new AttachSaleToDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachSaleToDeliveryRes$Type extends MessageType<AttachSaleToDeliveryRes> {
    constructor() {
        super("rd.api.delivery.AttachSaleToDeliveryRes", []);
    }
    create(value?: PartialMessage<AttachSaleToDeliveryRes>): AttachSaleToDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AttachSaleToDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AttachSaleToDeliveryRes): AttachSaleToDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AttachSaleToDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.AttachSaleToDeliveryRes
 */
export const AttachSaleToDeliveryRes = new AttachSaleToDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveStagedSaleToStopReq$Type extends MessageType<MoveStagedSaleToStopReq> {
    constructor() {
        super("rd.api.delivery.MoveStagedSaleToStopReq", [
            { no: 1, name: "delivery_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "stop_id", kind: "message", T: () => UUID },
            { no: 4, name: "staged_stop_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<MoveStagedSaleToStopReq>): MoveStagedSaleToStopReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MoveStagedSaleToStopReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MoveStagedSaleToStopReq): MoveStagedSaleToStopReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID delivery_id */ 1:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID stop_id */ 3:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                case /* rd.proto.uuid.UUID staged_stop_id */ 4:
                    message.stagedStopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stagedStopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MoveStagedSaleToStopReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID delivery_id = 1; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID stop_id = 3; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID staged_stop_id = 4; */
        if (message.stagedStopId)
            UUID.internalBinaryWrite(message.stagedStopId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.MoveStagedSaleToStopReq
 */
export const MoveStagedSaleToStopReq = new MoveStagedSaleToStopReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveStagedSaleToStopRes$Type extends MessageType<MoveStagedSaleToStopRes> {
    constructor() {
        super("rd.api.delivery.MoveStagedSaleToStopRes", []);
    }
    create(value?: PartialMessage<MoveStagedSaleToStopRes>): MoveStagedSaleToStopRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MoveStagedSaleToStopRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MoveStagedSaleToStopRes): MoveStagedSaleToStopRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MoveStagedSaleToStopRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.MoveStagedSaleToStopRes
 */
export const MoveStagedSaleToStopRes = new MoveStagedSaleToStopRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSaleFromStopReq$Type extends MessageType<RemoveSaleFromStopReq> {
    constructor() {
        super("rd.api.delivery.RemoveSaleFromStopReq", [
            { no: 1, name: "delivery_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "stop_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<RemoveSaleFromStopReq>): RemoveSaleFromStopReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveSaleFromStopReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveSaleFromStopReq): RemoveSaleFromStopReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID delivery_id */ 1:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 2:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID stop_id */ 3:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveSaleFromStopReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID delivery_id = 1; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 2; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID stop_id = 3; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.RemoveSaleFromStopReq
 */
export const RemoveSaleFromStopReq = new RemoveSaleFromStopReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSaleFromStopRes$Type extends MessageType<RemoveSaleFromStopRes> {
    constructor() {
        super("rd.api.delivery.RemoveSaleFromStopRes", []);
    }
    create(value?: PartialMessage<RemoveSaleFromStopRes>): RemoveSaleFromStopRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveSaleFromStopRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveSaleFromStopRes): RemoveSaleFromStopRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveSaleFromStopRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.RemoveSaleFromStopRes
 */
export const RemoveSaleFromStopRes = new RemoveSaleFromStopRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSaleFromDeliveryReq$Type extends MessageType<RemoveSaleFromDeliveryReq> {
    constructor() {
        super("rd.api.delivery.RemoveSaleFromDeliveryReq", [
            { no: 1, name: "sale_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stop_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<RemoveSaleFromDeliveryReq>): RemoveSaleFromDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveSaleFromDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveSaleFromDeliveryReq): RemoveSaleFromDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID sale_id */ 1:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID stop_id */ 2:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveSaleFromDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID sale_id = 1; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID stop_id = 2; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.RemoveSaleFromDeliveryReq
 */
export const RemoveSaleFromDeliveryReq = new RemoveSaleFromDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveSaleFromDeliveryRes$Type extends MessageType<RemoveSaleFromDeliveryRes> {
    constructor() {
        super("rd.api.delivery.RemoveSaleFromDeliveryRes", []);
    }
    create(value?: PartialMessage<RemoveSaleFromDeliveryRes>): RemoveSaleFromDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveSaleFromDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveSaleFromDeliveryRes): RemoveSaleFromDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveSaleFromDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.RemoveSaleFromDeliveryRes
 */
export const RemoveSaleFromDeliveryRes = new RemoveSaleFromDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryPDFReq$Type extends MessageType<GetDeliveryPDFReq> {
    constructor() {
        super("rd.api.delivery.GetDeliveryPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryPDFReq>): GetDeliveryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryPDFReq): GetDeliveryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryPDFReq
 */
export const GetDeliveryPDFReq = new GetDeliveryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryPDFRes$Type extends MessageType<GetDeliveryPDFRes> {
    constructor() {
        super("rd.api.delivery.GetDeliveryPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryPDFRes>): GetDeliveryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        message.fileName = "";
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryPDFRes): GetDeliveryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryPDFRes
 */
export const GetDeliveryPDFRes = new GetDeliveryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailDeliveryPDFReq$Type extends MessageType<EmailDeliveryPDFReq> {
    constructor() {
        super("rd.api.delivery.EmailDeliveryPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailDeliveryPDFReq>): EmailDeliveryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        if (value !== undefined)
            reflectionMergePartial<EmailDeliveryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailDeliveryPDFReq): EmailDeliveryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailDeliveryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.EmailDeliveryPDFReq
 */
export const EmailDeliveryPDFReq = new EmailDeliveryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailDeliveryPDFRes$Type extends MessageType<EmailDeliveryPDFRes> {
    constructor() {
        super("rd.api.delivery.EmailDeliveryPDFRes", []);
    }
    create(value?: PartialMessage<EmailDeliveryPDFRes>): EmailDeliveryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailDeliveryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailDeliveryPDFRes): EmailDeliveryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailDeliveryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.EmailDeliveryPDFRes
 */
export const EmailDeliveryPDFRes = new EmailDeliveryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryStopPDFReq$Type extends MessageType<GetDeliveryStopPDFReq> {
    constructor() {
        super("rd.api.delivery.GetDeliveryStopPDFReq", [
            { no: 1, name: "stop_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryStopPDFReq>): GetDeliveryStopPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryStopPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryStopPDFReq): GetDeliveryStopPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID stop_id */ 1:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryStopPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID stop_id = 1; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryStopPDFReq
 */
export const GetDeliveryStopPDFReq = new GetDeliveryStopPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeliveryStopPDFRes$Type extends MessageType<GetDeliveryStopPDFRes> {
    constructor() {
        super("rd.api.delivery.GetDeliveryStopPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetDeliveryStopPDFRes>): GetDeliveryStopPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetDeliveryStopPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeliveryStopPDFRes): GetDeliveryStopPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeliveryStopPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetDeliveryStopPDFRes
 */
export const GetDeliveryStopPDFRes = new GetDeliveryStopPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedDeliveryReq$Type extends MessageType<GetScannedDeliveryReq> {
    constructor() {
        super("rd.api.delivery.GetScannedDeliveryReq", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetScannedDeliveryReq>): GetScannedDeliveryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<GetScannedDeliveryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedDeliveryReq): GetScannedDeliveryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedDeliveryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetScannedDeliveryReq
 */
export const GetScannedDeliveryReq = new GetScannedDeliveryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedDeliveryRes$Type extends MessageType<GetScannedDeliveryRes> {
    constructor() {
        super("rd.api.delivery.GetScannedDeliveryRes", [
            { no: 1, name: "delivery", kind: "message", T: () => Delivery }
        ]);
    }
    create(value?: PartialMessage<GetScannedDeliveryRes>): GetScannedDeliveryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetScannedDeliveryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedDeliveryRes): GetScannedDeliveryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Delivery delivery */ 1:
                    message.delivery = Delivery.internalBinaryRead(reader, reader.uint32(), options, message.delivery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedDeliveryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Delivery delivery = 1; */
        if (message.delivery)
            Delivery.internalBinaryWrite(message.delivery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.GetScannedDeliveryRes
 */
export const GetScannedDeliveryRes = new GetScannedDeliveryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LatLng$Type extends MessageType<LatLng> {
    constructor() {
        super("rd.api.delivery.LatLng", [
            { no: 1, name: "lat", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "lng", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<LatLng>): LatLng {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lat = 0;
        message.lng = 0;
        if (value !== undefined)
            reflectionMergePartial<LatLng>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LatLng): LatLng {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double lat */ 1:
                    message.lat = reader.double();
                    break;
                case /* double lng */ 2:
                    message.lng = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LatLng, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double lat = 1; */
        if (message.lat !== 0)
            writer.tag(1, WireType.Bit64).double(message.lat);
        /* double lng = 2; */
        if (message.lng !== 0)
            writer.tag(2, WireType.Bit64).double(message.lng);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.LatLng
 */
export const LatLng = new LatLng$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizeDeliveryStopsReq$Type extends MessageType<OptimizeDeliveryStopsReq> {
    constructor() {
        super("rd.api.delivery.OptimizeDeliveryStopsReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "depart_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "origin", kind: "message", T: () => LatLng, options: { "rd.validator.require": true } },
            { no: 4, name: "stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OptimizeDeliveryStopsReq_Stop }
        ]);
    }
    create(value?: PartialMessage<OptimizeDeliveryStopsReq>): OptimizeDeliveryStopsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stops = [];
        if (value !== undefined)
            reflectionMergePartial<OptimizeDeliveryStopsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptimizeDeliveryStopsReq): OptimizeDeliveryStopsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp depart_at */ 2:
                    message.departAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.departAt);
                    break;
                case /* rd.api.delivery.LatLng origin */ 3:
                    message.origin = LatLng.internalBinaryRead(reader, reader.uint32(), options, message.origin);
                    break;
                case /* repeated rd.api.delivery.OptimizeDeliveryStopsReq.Stop stops */ 4:
                    message.stops.push(OptimizeDeliveryStopsReq_Stop.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptimizeDeliveryStopsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp depart_at = 2; */
        if (message.departAt)
            Timestamp.internalBinaryWrite(message.departAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.delivery.LatLng origin = 3; */
        if (message.origin)
            LatLng.internalBinaryWrite(message.origin, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.delivery.OptimizeDeliveryStopsReq.Stop stops = 4; */
        for (let i = 0; i < message.stops.length; i++)
            OptimizeDeliveryStopsReq_Stop.internalBinaryWrite(message.stops[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.OptimizeDeliveryStopsReq
 */
export const OptimizeDeliveryStopsReq = new OptimizeDeliveryStopsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizeDeliveryStopsReq_Stop$Type extends MessageType<OptimizeDeliveryStopsReq_Stop> {
    constructor() {
        super("rd.api.delivery.OptimizeDeliveryStopsReq.Stop", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "location", kind: "message", T: () => LatLng },
            { no: 3, name: "window", kind: "message", T: () => TimestampRange },
            { no: 4, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OptimizeDeliveryStopsReq_Stop>): OptimizeDeliveryStopsReq_Stop {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial<OptimizeDeliveryStopsReq_Stop>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptimizeDeliveryStopsReq_Stop): OptimizeDeliveryStopsReq_Stop {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.api.delivery.LatLng location */ 2:
                    message.location = LatLng.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.proto.timestamprange.TimestampRange window */ 3:
                    message.window = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.window);
                    break;
                case /* string label */ 4:
                    message.label = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptimizeDeliveryStopsReq_Stop, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.delivery.LatLng location = 2; */
        if (message.location)
            LatLng.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange window = 3; */
        if (message.window)
            TimestampRange.internalBinaryWrite(message.window, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string label = 4; */
        if (message.label !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.label);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.OptimizeDeliveryStopsReq.Stop
 */
export const OptimizeDeliveryStopsReq_Stop = new OptimizeDeliveryStopsReq_Stop$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizeDeliveryStopsRes$Type extends MessageType<OptimizeDeliveryStopsRes> {
    constructor() {
        super("rd.api.delivery.OptimizeDeliveryStopsRes", [
            { no: 1, name: "routed_stops", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OptimizeDeliveryStopsRes_RoutedStop },
            { no: 2, name: "return_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<OptimizeDeliveryStopsRes>): OptimizeDeliveryStopsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.routedStops = [];
        if (value !== undefined)
            reflectionMergePartial<OptimizeDeliveryStopsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptimizeDeliveryStopsRes): OptimizeDeliveryStopsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop routed_stops */ 1:
                    message.routedStops.push(OptimizeDeliveryStopsRes_RoutedStop.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp return_at */ 2:
                    message.returnAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.returnAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptimizeDeliveryStopsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop routed_stops = 1; */
        for (let i = 0; i < message.routedStops.length; i++)
            OptimizeDeliveryStopsRes_RoutedStop.internalBinaryWrite(message.routedStops[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp return_at = 2; */
        if (message.returnAt)
            Timestamp.internalBinaryWrite(message.returnAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.OptimizeDeliveryStopsRes
 */
export const OptimizeDeliveryStopsRes = new OptimizeDeliveryStopsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizeDeliveryStopsRes_RoutedStop$Type extends MessageType<OptimizeDeliveryStopsRes_RoutedStop> {
    constructor() {
        super("rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop", [
            { no: 1, name: "stop_id", kind: "message", T: () => UUID },
            { no: 2, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "arrive_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "misses_window", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<OptimizeDeliveryStopsRes_RoutedStop>): OptimizeDeliveryStopsRes_RoutedStop {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.position = 0;
        message.missesWindow = false;
        if (value !== undefined)
            reflectionMergePartial<OptimizeDeliveryStopsRes_RoutedStop>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptimizeDeliveryStopsRes_RoutedStop): OptimizeDeliveryStopsRes_RoutedStop {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID stop_id */ 1:
                    message.stopId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.stopId);
                    break;
                case /* int32 position */ 2:
                    message.position = reader.int32();
                    break;
                case /* google.protobuf.Timestamp arrive_at */ 3:
                    message.arriveAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.arriveAt);
                    break;
                case /* bool misses_window */ 4:
                    message.missesWindow = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptimizeDeliveryStopsRes_RoutedStop, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID stop_id = 1; */
        if (message.stopId)
            UUID.internalBinaryWrite(message.stopId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 2; */
        if (message.position !== 0)
            writer.tag(2, WireType.Varint).int32(message.position);
        /* google.protobuf.Timestamp arrive_at = 3; */
        if (message.arriveAt)
            Timestamp.internalBinaryWrite(message.arriveAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool misses_window = 4; */
        if (message.missesWindow !== false)
            writer.tag(4, WireType.Varint).bool(message.missesWindow);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.delivery.OptimizeDeliveryStopsRes.RoutedStop
 */
export const OptimizeDeliveryStopsRes_RoutedStop = new OptimizeDeliveryStopsRes_RoutedStop$Type();
/**
 * @generated ServiceType for protobuf service rd.api.delivery.DeliveryService
 */
export const DeliveryService = new ServiceType("rd.api.delivery.DeliveryService", [
    { name: "GetDelivery", options: {}, I: GetDeliveryReq, O: GetDeliveryRes },
    { name: "CreateDelivery", options: {}, I: CreateDeliveryReq, O: CreateDeliveryRes },
    { name: "UpdateDelivery", options: {}, I: UpdateDeliveryReq, O: UpdateDeliveryRes },
    { name: "UpdateDeliveryStop", options: {}, I: UpdateDeliveryStopReq, O: UpdateDeliveryStopRes },
    { name: "StageSale", options: {}, I: StageSaleReq, O: StageSaleRes },
    { name: "UnstageSale", options: {}, I: UnstageSaleReq, O: UnstageSaleRes },
    { name: "AttachSaleToDelivery", options: {}, I: AttachSaleToDeliveryReq, O: AttachSaleToDeliveryRes },
    { name: "MoveStagedSaleToStop", options: {}, I: MoveStagedSaleToStopReq, O: MoveStagedSaleToStopRes },
    { name: "RemoveSaleFromStop", options: {}, I: RemoveSaleFromStopReq, O: RemoveSaleFromStopRes },
    { name: "RemoveSaleFromDelivery", options: {}, I: RemoveSaleFromDeliveryReq, O: RemoveSaleFromDeliveryRes },
    { name: "GetDeliveryPDF", options: {}, I: GetDeliveryPDFReq, O: GetDeliveryPDFRes },
    { name: "EmailDeliveryPDF", options: {}, I: EmailDeliveryPDFReq, O: EmailDeliveryPDFRes },
    { name: "GetDeliveryStopPDF", options: {}, I: GetDeliveryStopPDFReq, O: GetDeliveryStopPDFRes },
    { name: "GetScannedDelivery", options: {}, I: GetScannedDeliveryReq, O: GetScannedDeliveryRes },
    { name: "OptimizeDeliveryStops", options: {}, I: OptimizeDeliveryStopsReq, O: OptimizeDeliveryStopsRes }
]);
